module.exports = __webpack_public_path__ + "img/Plastic Omnium.4e7d4b74.jpg";